import VI from './VI';

export default {
  quickActions: '快捷操作',
  servers: {
    name: '服务器',
    auto: '自动',
    vietnam: '越南',
    singapore: '新加坡',
    main: '主要的',
    reserve: '预防性'
  },
  boss: '店主',
  cart: '购物车',
  line: '当前的',
  gotit: '明白了',
  timezone: '时区',
  timezoneHint: '更新时区可能会更改报告的数据',
  collapse: '坍塌',
  expand: '延长',
  salesman: '卖方',
  download: '下载',
  sort: '安排',
  appNotAvailable: '该应用程序尚不可用。请稍后再试！',
  getStart: '开始',
  itemPerPage: '每页数量',
  takeAway: '把它带回来',
  printBill: '打印发票（Bill）',
  barcodeText: '代码（文字）',
  now: '现在',
  hour: '小时',
  minutes: '分钟',
  second: '第二',
  limitFeatureForFree: '此功能仅适用于高级版本。请升级才能使用此功能！',
  orderIsPaying: '订单正在支付中',
  canUpdateOrder: '您确定要取消吗？更改不会更新！',
  charge: '准备账单',
  checkout: '准备账单',
  commingSoon: '尚不可用',
  upcoming: '即将推出',
  close: '关闭',
  showing: '显示中',
  addShortCut: '附加快捷方式',
  billUIChoice: '选择发票界面',
  qrUIChoice: '选择二维码界面',
  devicePermissionDenied: '您需要授予应用程序执行此功能的权限！',
  permissionNotifyInfo: '您需要授予通知权限才能使用此功能！',
  oldVersion: '旧版本',
  changeText: '改变',
  confirmDelete: '您确定要删除该项目吗？',
  value: '价值',
  deprecated: '即将退出',
  saving: '节省',
  active: '激活',
  notActive: '尚未激活',
  hidden: '隐',
  content: '内容',
  featureUnderDev: '这个功能正在由我们团队完成。请稍后再回来！！',
  spending: '花费',
  overview: '概述',
  recommend: '受到推崇的',
  savePdf: '保存 pdf 文件',
  bankQR: '二维码STK',
  quantityInvalid: '数量无效',
  returnToHome: '返回主屏幕',
  forever: '永远',
  expired: '已到期',
  expiredShort: 'HSD',
  barcodeTable: '产品条码表',
  price: '价格',
  autoGen: '自动生成',
  check: '查看',
  signature: '签名',
  permission: '去中心化',
  staffLogin: '员工登录',
  staffSale: '销售代理',
  updateInfo: '更新信息',
  staffPermission: {
    title: '向员工授权',
    detail: '授权员工直接在管理WEB/APP上使用。仅限员工使用的应用程序可能不具备其中某些功能',
    allOrderType: '销售订单、进口货物、退货',
    showRevenue: '显示订单利润',
    editPriceDetail: '允许员工在销售期间编辑销售价格。否则，产品将以零售价出售。',
    financial: '收据和支出单',
    showAllCustomer: '显示所有客户',
    showAllCustomerDetail: '访问所有客户，即使这些客户不是由该员工创建的',
    editPrice: '允许您编辑售价',
    showAllOrder: '显示所有订单',
    showAllOrderDetail: '显示经理和其他员工的所有订单',
    canViewFinancialStats: '查看现金流量',
    canViewFinancialStatsDetail: '允许员工查看他们的现金流量报告',
    canViewDebtStats: '查看债务',
    canViewDebtStatsDetail: '查看整个商店的债务',
    canViewWarehouseStats: '查看库存报告',
    canViewWarehouseStatsDetail: '查看仓库状态报告',
    canViewSalesStats: '查看收入报告',
    canViewSalesStatsDetail: '查看整个商店的销售报告',
    canExportEInvoice: '导出电子发票',
    canExportEInvoiceDetail: '员工可以开具电子发票',
    roleAndAccess: '角色和访问权限',
    roleAndAccessSubtitle: '为员工配置角色和仓库访问权限',
    role: '角色',
    roleManager: '管理',
    roleRegular: '正式员工',
    warehouseAccess: '仓库存取',
    allWarehouses: '全部库存',
    selectWarehouses: '选择要访问的存储库：',
    warehouseAccessDenied: '您没有权限访问此存储库',
    managerNote: '经理拥有除更新商店账户和管理员工之外的所有权利。',
    dataOperation: '数据操作权限',
    featuresAndStats: '查看与功能权限'
  },
  renew: '立即购买',
  updatedAt: '更新于',
  saveDraft: '吕一',
  buy: '买',
  birthday: '生日',
  barcodeNotFound: '找不到该条形码！',
  saved: '已保存',
  reality: '现实',
  difference: '不同之处',
  hide: '隐藏',
  editComponent: '编辑组件',
  amount: '数量',
  search: '搜索',
  simple: '简单的',
  more: '更多的',
  share: '分享',
  inventoryDelivery: '仓库放行说明',
  type: '类型',
  transactionHistory: '交易记录',
  limitWarning: '由于多次退款，您的帐户受到限制。如果超过3次，账户将被永久锁定，数据无法恢复。谢谢你！',
  upgradePro: '升级',
  iapSupport: '6 个月以上的包裹通过银行转账付款可享受 5% 的折扣。请通过 Facebook Messenger 联系以获取建议',
  emptyData: '还没有数据',
  seemore: '查看更多',
  version: '版本',
  financialIn30days: '过去 30 天内的财务状况',
  financialInMonth: '本月财务',
  orFastLoginWith: '或使用谷歌、苹果登录',
  fontSize: '字体大小',
  changeFontSizeWarning: '字体大小已更改。您应该退出应用程序并重新进入才能使应用程序稳定运行',
  fontSizeList: ['很小', '小的', '合身', '大的', '很大', '非常非常大'],
  contact: '联系方式',
  cause: '原因',
  default: '默认',
  manager: '管理',
  paymentMethod: '付款方式',
  closeWarning: '您确定要禁用此功能吗？',
  paymentMethodList: ['现金', '转移', '借方'],
  printerVideoDemo: '视频连接说明',
  supportWarning: '如果您需要支持，请通过 Facebook 渠道联系开发团队。 \n感谢您的合作！',
  offlineWarning: '您正在离线使用。您应该注册一个在线帐户以避免数据丢失，并且可以使用许多其他功能以及使用计算机版本。',
  updating: '更新中',
  loadingData: '准备数据',
  loadingHint: '系统正在处理中，请稍候...',
  remain: '其余的',
  choiceProductTypeWarning: '请选择产品分类',
  choiceProductUnitConvertWarning: '请选择商品单位',
  editProduct: '修理品',
  onlyOnlineSupport: '该功能仅支持在线。请登录您的帐户才能使用此功能！',
  createBy: '创建者：',
  userName: '登录名',
  fullName: '姓名',
  webVersion: '网页版（电脑）',
  webVersionBackup: '备份网站',
  syncingProgress: '正在进行同步。请等待 1 - 15 分钟。该过程完成后，我们会向您发送一封电子邮件',
  bulkDelete: '批量删除',
  sync: '同步',
  offline: '离线',
  offlineNotSupport: '仅支持网络版',
  warning: '警告',
  back: '返回',
  yes: '有',
  no: '不是',
  refresh: '刷新',
  tryAgain: '重试',
  home: '主页',
  language: '语言',
  theme: '界面',
  dark: '黑暗的',
  light: '明亮的',
  total: '全部的',
  quantity: '数量',
  totalMoney: '总金额',
  paid: '有薪酬的',
  totalDebit: '未偿债务总额',
  totalReminder: '剩余总计',
  totalOldDebit: '旧债',
  totalOldReminder: '旧余额',
  blanceAndDebt: '余额/债务',
  debit: '仍负债累累',
  remainder: '残差',
  arrears: '其余的',
  status: '地位',
  create: '添加新的',
  add: '更多的',
  save: '节省',
  saveImage: '保存照片',
  next: '继续',
  print: '打印',
  oldPrint: '打印账单（简单）',
  export: '开具发票',
  edit: '使固定',
  copy: '复制',
  copied: '复制了！',
  delete: '删除',
  update: '更新',
  updateStatus: '更新状态',
  day: '天',
  month: '月',
  year: '年',
  from: '从',
  to: '到达',
  fromDate: '开始日期',
  toDate: '结束日期',
  choiceImage: '选择照片',
  exist: '存在过',
  invalidParams: '请输入带星号的所有数据',
  success: '成功',
  fail: '失败',
  all: '全部',
  complete: '完全的',
  pending: '等待',
  canceled: '取消',
  cancel: '取消',
  ok: '同意',
  or: '或者',
  choice: '选择',
  confirm: '确认',
  confirmExitApp: '您想退出应用程序吗？',
  time: '时间',
  notFound: '没有找到数据。请再试一次！',
  createdAt: '创建日期',
  none: '没有',
  detail: '细节',
  filter: '筛选',
  filterByTim: '按时间过滤',
  note: '笔记',
  trial: '尝试一下',
  option: '选项',
  notify: '通知',
  understand: '天气晴朗',
  exportToExcel: '导出Excel',
  multiHidden: '散装皮',
  multiActive: '批量激活',
  hiddenList: '隐藏列表',
  showList: '激活列表',
  importDataFromExcel: '从 Excel 导入',
  describe: '产品描述',
  addImage: '添加照片',
  limitUpload: '每个产品最多支持5张照片',
  limitFeature: {
    intro: '请完全免费体验。并在您真正需要时付款',
    free: '免费版',
    pro: '高级版',
    title: '您需要购买高级版本才能使用此功能',
    package: '高级管理包',
    packageOther: '其他服务套餐',
    features: [
      '无广告',
      '无限商品',
      '无限订单',
      '产品条码打印功能（网页版）',
      '客户积分累积功能',
      '订单复制功能',
      '具有由卖家支付的额外费用',
      '退货功能',
      '隐藏旧货的功能',
      '产品分类特征（示例：牛仔裤产品尺码分类为M、L、XL）',
      '将数据导入和导出到 Excel 文件的功能',
      '添加收据和付款单的功能',
      '向客户添加旧债务单的功能',
      '创建仓库交货单的功能',
      '创建仓库交货单的功能',
      '创建二维码直接支付订单的功能',
      '草稿订单功能（无网络时创建订单）',
      '每个产品最多可上传5张照片',
      '无限制使用网页版（桌面版）'
    ],
    freeFeatures: [
      '是否显示广告',
      '限量 100 件。',
      '仅限 2,000 份订单。',
      '隐藏旧货的功能',
      '具有由卖家支付的额外费用',
      '退货功能',
      '产品条码打印功能',
      '客户积分累积功能',
      '产品分类特点',
      '打印或导出发票功能',
      'Excel导出功能',
      '添加收入和支出的功能',
      '添加债务的功能',
      '从 Excel 文件导入商品和客户的功能',
      '创建仓库交货单的功能',
      '单位换算功能',
      '每个表面限制 1 个图像',
      '限制创建支付二维码的能力',
      '免费使用网页版 3 个月'
    ]
  },
  syncDetail: {
    text1: '将数据从您的设备同步到您的帐户。这个过程只需要完成一次。',
    text2: '每个账户只能同步成功一次',
    text3: '该功能仍在测试中。如果遇到错误，请尽快联系开发者寻求支持。',
    start: '开始同步',
    sendErrorData: '发送数据错误',
    feedback: '反馈给开发商',
    sure: '您确定要与此帐户同步数据吗？',
    syncedError: '该账号已同步',
    syncedAlert: '您的账户尚未同步离线数据。您想现在同步吗？'
  },
  account: {
    systemSmartSubtitle: '智能销售管理系统',
    switch: '账户转账',
    switchConfirm: '您确定要切换到帐户 %s 吗？',
    switchDeleteConfirm: '您确定要删除帐户 %s 的登录会话吗？',
    requiredInfo: '请输入完整信息',
    enterCodeRequired: '请输入确认码',
    enterPasswordRequired: '请输入完整密码',
    passwordNotMatch: '两个密码不相同',
    loginSubtitle: '欢迎回来！',
    registerSubtitle: '今天就加入我们吧！',
    noAccountYet: '还没有帐户？',
    alreadyHaveAccount: '已经有帐户？',
    forgotPasswordStepEmail: '输入您的电子邮件以开始密码恢复。',
    forgotPasswordStepCode: '请检查发送至您邮箱的 6 位验证码。',
    forgotPasswordStepPassword: '使用强密码来保护您的帐户。',
    backToLogin: '返回登录',
    sendCodeSuccess: '我们已发送一封包含代码的电子邮件。请检查您的电子邮件以获取确认码',
    errorCode: '验证码不正确',
    codeExpired: '验证码已过期。',
    forgotPassword: '忘记密码',
    enterEmail: '输入您的电子邮件',
    enterCode: '输入确认码',
    sendCode: '发送确认码',
    submitCode: '确认',
    changePassword: '更改密码',
    newPassword: '新密码',
    renewPassword: '重置新密码',
    password: '密码',
    repassword: '重新输入密码',
    register: '登记',
    inputSoShort: '用户名或密码太短',
    repassWrong: '重新输入的密码不正确',
    emailExist: '电子邮件已存在',
    logout: '登出',
    login: '登录',
    loginWithoutEmail: '无需电子邮件登录',
    loginWithoutEmailError: '无法生成设备代码时出错。请联系支持人员获取说明！',
    offlineMode: '离线使用',
    offlineModeWarning: '离线使用时，数据将保存在您的设备上。您需要先登录，然后再切换到其他设备，以免丢失数据',
    offlineDeprecated: '从2025年3月13日起。该应用程序不再支持离线功能。 \n免费离线使用。请下载 aSeller 离线应用程序（该应用程序有一个橙色图标）。\n谢谢！',
    logoutConfirmMessage: '您确定要退出该帐户吗？',
    notFoundEmail: '未找到此电子邮件的帐户',
    errorPassword: '密码不正确',
    emailInvalid: '电子邮件格式不正确',
    titleRequest: '我们收到了更改与此电子邮件关联的密码的请求。',
    enterCodeEmail: '输入发送到您的电子邮件的验证码。如果找不到，请检查电子邮件客户端的垃圾邮件或垃圾邮件文件夹。'
  },
  schedule: {
    title: '日程管理',
    add: '添加时间表',
    requiredInfo: '请填写所有信息',
    updateError: '更新时间表时出错',
    createError: '创建计划时出错',
    updateSuccess: '更新日程成功',
    createSuccess: '成功创建新计划',
    deleteError: '删除日程时出错',
    deleteSuccess: '已成功删除日程',
    pending: '等待',
    completed: '完全的',
    name: '姓名',
    value: '价值',
    time: '时间',
    status: '地位',
    action: '行为',
    edit: '使固定',
    editTitle: '编辑日程',
    createTitle: '创建新时间表',
    namePlaceholder: '输入计划名称',
    valuePlaceholder: '输入值',
    deleteTitle: '删除日程',
    deleteConfirm: '您确定要删除此计划吗？'
  },
  statitical: {
    chart: '图表',
    title: '报告与统计',
    sale: '销售量',
    debtBook: '借记簿',
    revenue1: '收入',
    revenue: '利润',
    profit: '利润',
    capital: '资本价格',
    costOfCapital: '资本成本',
    expense: '费用',
    saleToday: '今天',
    sale7Days: '7天',
    sale30Days: '30天',
    chart7Days: '最近7日图',
    saleTitle: '销售统计',
    revenueTitle: '利润统计',
    orderTitle: '订单统计',
    returnOrderTitle: '退货统计',
    order: '命令',
    stock: '仓库统计',
    quantityOfInventory: '按单位库存',
    quantityOfInventoryByCategory: '库存按类别',
    inventoryCapital: '库存资金',
    inventoryCapitalDetail: '（相对当前成本价计算）',
    quantityOfInventoryProduct: '大部分库存商品',
    saleOfStaff: '员工流动率',
    choiceToView: '选择报告类型和时间段以查看更详细的信息',
    choiceType: '报告类型',
    oldStaticWarning: '该报告已根据您所在时区使用标准数据进行更新。'
  },
  menu: {
    category: '类别',
    statitical: '报告与统计',
    oldStatitical: '统计（旧）',
    version: '版本',
    other: '其他',
    setting: '环境',
    shortcut: '捷径',
    account: '帐户',
    feedback: '反馈与建议',
    share: '将此应用程序发送给您的朋友',
    reportBug: '发送错误报告数据',
    reportLogBug: '发送错误日志',
    policy: '隐私政策',
    term: '使用条款',
    editProfile: '更新信息',
    editProfileDetail: '更新商店信息，使其完整显示在发票上。',
    orderReturn: '退货表格',
    support: '支持'
  },
  settingForStaff: {
    title: '商店设置',
    staff: '职员',
    staffApp: '其他 aSeller 应用程序',
    branch: '区域',
    branchHint: '此部分仅针对服务业务接口。比如一楼、二楼……',
    cafe: '咖啡厅及餐厅',
    passForStaff: '员工密码',
    passForStaffDetail: '员工登录销售应用程序时需要使用单独的密码。不要将其设置为与您的主密码相同',
    mainBranch: '主要的',
    addBranch: '添加区域',
    editBranch: '编辑区',
    addStaff: '更多员工',
    editStaff: '编辑人员',
    table: '桌子',
    branchName: '地区名称',
    branchTable: '桌数',
    staffs: '人事管理',
    staffsDetail: '每家商店将为第一位员工提供 1 个月的免费试用期。',
    addStaffSubtitle: '为员工创建新帐户',
    editStaffSubtitle: '更新员工账户',
    accountInfo: '账户信息',
    personalInfo: '个人信息',
    placeholderUserName: '用户名...',
    placeholderPasswordEdit: '如果未更改则留空',
    placeholderPassword: '密码...',
    placeholderFullName: '姓名...',
    placeholderPhone: '电话号码...',
    placeholderAddress: '地址...',
    placeholderNote: '工作人员注意事项...',
    emptyStaff: '还没有工作人员。',
    upgradeStaff: '延长',
    appForStaffIntro: '员工应用程序列表，您的员工可以使用此应用程序创建订单。您需要创建一个员工帐户才能使用它。数据将同步到您的主帐户。',
    emailExist: '用户名已存在',
    shopType: '业务类型',
    grocery: '杂货店、超市',
    appForStaff: ['a卖家销售人员'],
    appForStaffDetail: ['此应用程序适用于员工。您可以在“员工管理-更多”中创建员工账户'],
    shopTypeDetail: '选择正确的业务类型以在员工销售应用程序上使用正确的界面',
    showCustomer: '向员工展示顾客',
    showCustomerDetail: '在员工应用程序上显示客户列表',
    customerShowMode: ['显示全部', '仅限工作人员客人', '未显示'],
    upgradeStaffContact: '为员工续约。请联系',
    service: '服务',
    serviceDetail: '商店、咖啡馆、奶茶、餐厅……',
    retail: '卖得快',
    retailDetail: '杂货店、超市...',
    showStatistial: '显示每周销售额',
    showStatistialDetail: '允许员工查看最近 7 天的销售额',
    stockEnabled: '向员工显示库存',
    stockEnabledDetail: '在员工应用程序上显示库存和销售数字',
    uiForStaft: '员工销售界面',
    uiForStaftDetail: '选择合适的界面，为您的员工提供最大的便利',
    typeCafe: '有一个表格列表以便于跟踪。适合餐厅、商店、咖啡馆、奶茶店等业态...',
    typeRetail: '简单的界面。适合零售和批发，只需要一个简单而有效的界面。',
    typeSalesCounter: '计数器接口。适合柜台人员，专业高效',
    counter: '柜台',
    productList: '产品列表',
    productListDetail: '设置为每个员工显示的产品列表。默认显示所有产品',
    tableManager: '订单表'
  },
  prefix: {
    title: '前缀',
    detail: '订单代码、商品等前面出现的字符串，例如订单代码：HD123'
  },
  setting: {
    advanced: '先进的',
    customerCanRegister: '允许客户注册帐户',
    customerCanRegisterDetail: '客户可以注册自己的帐户。客户可以跟踪他们的订单和发票。',
    vote: '评价该应用程序！',
    about: '介绍',
    title: '常规设置',
    help: '使用说明',
    currency: '货币单位',
    timeFormat: '日期格式',
    oddNumber: '使用奇数单位',
    oddNumberEx: '例如1000.15VND，0.5KG...',
    sync: '数据',
    login: '登录',
    logout: '登出',
    notSignin: '尚未登录',
    syncIntro: '登录您的 Google 帐户备份您的数据以确保数据安全，并且可以将其转移到其他设备',
    syncNow: '立即备份',
    lastSync: '上次备份于',
    restore: '恢复数据',
    requireLogin: '您需要登录您的 Google 帐户才能执行此功能',
    syncNotFound: '未找到备份',
    confirmSync: '服务器上的数据将被覆盖。您确定要同步数据吗？',
    confirmRestore: '您确定要恢复数据，现有数据会被覆盖吗？',
    loginExpired: '登录会话已过期。请重新登录！',
    autoBackup: '自动备份数据',
    googleAccountConnect: '谷歌帐户',
    on: '打开',
    off: '关',
    googleLogoutConfirm: '您确定要退出此 Google 帐户吗？',
    print: '连接打印机',
    printDetail: '选择您的蓝牙打印机连接并打印货物收据',
    connectPrinter: '打印机',
    invoice: '账单',
    invoiceHello: '谢谢',
    surchargeText: '更改发票上的附加费文字',
    invoiceSignature: '显示签名',
    invoiceDebt: '显示未结余额',
    invoiceDebtInfo: '在订单详细信息中显示未结余额',
    debt: '未偿债务',
    invoiceDebtDetail: '详细的未结余额',
    invoiceDebtDetailDetail: '显示借项单的简化版本中的详细项目',
    invoiceDiscount: '显示折扣百分比',
    invoiceHelloDetail: '编辑发票下方致客户的感谢信',
    warningOutStock: '缺货警告',
    warningOutStockDetail: '缺货时，无法将商品添加到订单中',
    warningOutStockMessage: '您的商品缺货。请在设置中添加或禁用此警告',
    showRevenue: '显示利润',
    orderStatus: '显示订单状态',
    orderStatusDetail: '显示状态“待处理”或“已完成”。如果启用，将无法创建订单收据。',
    showHomeRevenue: '显示利润',
    showHomeChart: '显示图表',
    showHomeFinancial: '金融展示',
    showHomeStatistial: '显示统计数据',
    averageBuyPrice: '平均成本价',
    averageBuyPriceDetail: '每次导入后会自动平均成本价，以便更准确地计算利润。\n公式 = (当前总库存 + 新库存金额)/(总数量)',
    bankInfo: '银行账户',
    vietQRCode: '支付二维码',
    vietQRCodeDetail: '扫描VietQR码即可快速付款。这包括有关订单金额和转账内容的信息。',
    vietQRCodeWarning: '请输入正确的账户信息。如果您的信息输入错误，我们将不承担任何责任！',
    bankName: '银行名称',
    bankAcc: '帐号',
    bankAccName: '账户持有人姓名',
    bankTransferContent: '传输内容',
    showSurchargeShopPay: '显示店铺支付的附加费',
    showSurchargeShopPayDetail: '如果不选择，卖家支付的附加费将不会显示在账单或发票上',
    debtActive: '激活债务',
    debtActiveDetail: '激活债务以跟踪客户的债务。如果您关闭与债务相关的功能（例如：订单收据、客户收据、借记簿...），它们将无法工作。',
    debtInactiveDetail: '债务功能已被禁用。如需激活，请前往“设置”->“订单设置”->“激活未结余额”',
    inventoryActive: '启用库存跟踪',
    inventoryActiveDetail: '监控仓库中的库存量。如果关闭，所有与库存相关的功能将无法使用。\n如果您经营服务业务，例如咖啡馆、餐厅...，您应该关闭此功能以简化使用流程。',
    inventoryInactiveDetail: '当您关闭库存跟踪时，此功能不起作用。如需激活，请前往“设置”->“商品设置”->“激活库存”。',
    inventoryActiveWarning: '如果将其关闭，所有与库存相关的功能将无法使用。您确定要停用吗？'
  },
  customer: {
    id: '宾客代码',
    prefix: '客户代码前缀',
    title: '客户',
    create: '添加客户',
    name: '客户名称',
    address: '地址',
    phone: '电话号码',
    email: '电子邮件',
    add: '添加新客户',
    choice: '选择客户',
    invalidPhoneOrAddress: '请输入电话号码或地址',
    phoneExist: '该电话号码已存在',
    search: '按姓名、电话号码、税码、身份证号码搜索...',
    free: '零售客户',
    freeDetail: '拜访客户',
    orderStatistics: '订单统计',
    exportDebt: '发行债务票据',
    addDebt: '添加债务',
    yearOld: '岁',
    countBirthDay: '还剩 %s 天',
    taxCode: '税码',
    citizenId: '识别码',
    exportOrderExcel: '将订单列表导出到 Excel',
    purchasedProducts: '购买的商品',
    taxCodeHint: '可以通过税码搜索组织',
    createScreen: {
      taxCodeNotFound: '未找到税号信息',
      avatarLabel: '头像',
      contactHint: '可从通讯录快速填写信息或添加头像',
      basicInfoTitle: '基本信息'
    },
    deleteWarning: '您确定要删除该客户吗？与该客户相关的所有订单和收据都将转移给零售客户。'
  },
  order: {
    lastPrice: '最近价格',
    lastPriceAuto: '自动使用最近售价',
    lastPriceAutoDetail: '客户订单将自动使用该客户最近的售价，而不是零售价',
    addDisplayInfo: '添加显示信息',
    editDeadline: '订单编辑期限',
    editDeadlineDetail: '允许从创建订单之日起在此天数内编辑订单。',
    editDeadlineExpired: '订单已超过编辑期限。请在“设置”->“订单设置”中调整允许编辑订单的期限。',
    summary: '订单汇总',
    id: '单码',
    prefix: '订购代码前缀',
    title: '销售订单',
    create: '添加销售订单',
    edit: '编辑订单',
    detail: '订单详情',
    exportInvoice: '付款发票',
    add: '添加产品',
    infoShop: '店铺信息',
    invalidCustomer: '请选择客户信息',
    invalidProduct: '订单中没有产品',
    confirmDelete: '您确定要删除这个 %s 吗？',
    search: '按订单代码、客户姓名或电话号码过滤',
    discount: '折扣',
    realPrice: '实际价格计算',
    discount1: '折扣（折扣）',
    inStockNotEnough: '库存商品数量不够。请添加更多商品，或更新库存数量。',
    createFailed: '订单创建失败。请重试或回复开发者。',
    surcharge: '额外费用',
    surchargeDetail: '（运费、税收、旧债……）',
    barcodeNotFound: '该条形码尚不存在。请先输入商品，然后再将其添加到订单中',
    price: '价格',
    customPrice: '定制定价',
    customPrice1: '减少%',
    orderMoneyUpdated: '订单价值因售价变化而更新',
    totalProductMoney: '商品总成本',
    totalMustPaidMoney: '应付总额',
    totalMustPaidMoneyForCustomer: '总计必须返还给客户',
    totalPaidMoney: '有薪酬的',
    totalDebtMoney: '客户还欠钱',
    paid: '有薪酬的',
    totalLiabilities: '未偿债务总额',
    totalPaidMoneyForCustomer: '回头客',
    providerRefunds: '供应商退货',
    providerDebt: '仍欠供应商',
    pointDiscount: '扣除累积积分',
    money: '订单总额',
    statusOffRequire: '关闭订单状态',
    statusOffRequireDetail: '创建订单收据。您必须关闭订单状态，因为当涉及到订单的未结余额时，这可能会造成混乱。您确定要关闭订单状态才能使用此功能吗？',
    surchargeType2: '卖家付款',
    surchargeType1: '买家付款',
    surchargeTypeHint: '- 买家付款：会计入订单金额，计入收入，不计入利润。\n- 卖家付款：不会计入订单金额，会创建相应的付款凭证，用于计算店铺费用',
    table: '桌子',
    changeTable: '更改表',
    changeTableInput: '输入要更改的桌号',
    separate: '单独的菜肴',
    separateDetail: '将同一销售订单中的产品拆分为多行',
    promotionAuto: '自动应用促销',
    promotionAutoDetail: '自动将您选择的最新促销活动应用于您的订单',
    emptyProduct: '请添加项目',
    draftOrderWarning: '注意：这是临时发票，尚未保存在数据中。',
    draftSaved: '已保存申请草稿。草稿申请清单请在“首页”查看',
    vatDetail: '税（增值税）根据货物的增值税自动计算。此函数太旧了，您应该对商品使用税收函数 (VAT) 以获得更准确的结果。',
    productSorting: '按订单排列货物',
    productSortingDetail: '稍后添加的商品将显示在列表底部。停用将显示在列表顶部',
    description: '管理和跟踪您的所有销售订单。'
  },
  product: {
    multiStopSale: '批量停止销售',
    multiSale: '批量销售商品',
    stopSale: '停止销售',
    sale: '销售',
    stopSaleList: '停止销售列表',
    saleList: '销售中列表',
    product: '产品',
    id: '商品编码',
    prefix: '商品代码前缀',
    title: '商品',
    create: '更多商品',
    add: '更多商品',
    choice: '选择商品',
    name: '商品名称',
    priceType: '选择价格',
    price: '商品价格',
    buyPrice: '资本价格',
    sellPrice: '零售价',
    sellPrice1: '促销价',
    sellPrice2: '批发价',
    recent: '最近添加的产品',
    search: '按产品代码和名称过滤',
    sold: '卖',
    inStock: '存货',
    initStock: '初始数量',
    initStockDetail: '创建新产品时的初始库存数量',
    vatDetail: '税金根据销售订单计算',
    vat: '税（增值税）',
    expirationDate: '截止日期',
    outOfStock: '缺货',
    barcode: '代码 代码',
    exist: '商品已经存在。请再次检查名称或条形码',
    canNotDelete: '您无法删除该商品，因为它已在订单中。请先删除订单。',
    errorPrice: '销售价或成本价无效',
    changeSellPriceWarning: '注：价格变动会影响现有订单',
    changeSellPriceWarningDetail: '更改售价将影响现有订单，您必须更新包含该商品的订单。您确定要这样做吗？',
    deleteNumProduct: '删除 %s 项',
    deleteNumProductConfirm: '您确定要删除 %s 此项吗？',
    hiddenNumProduct: '停止销售 %s 项目',
    activeNumProduct: '销售 %s 项目',
    hiddenNumProductConfirm: '您确定要停止销售 %s 此项吗？',
    activeNumProductConfirm: '您确定要销售 %s 此项吗？',
    canNotDeleteProduct: '您无法删除商品 %s，因为它已在订单中。',
    syncAmount: '库存数量与进口订单同步',
    syncAmountConfirm: '该商品的库存数量为 %s。您想再次更新吗？',
    barcodeExist: '另一个商品已存在该条形码。',
    combo: '套餐',
    comboProduct: '套餐商品',
    comboRecipe: '套餐配方',
    comboRecipeHint: '套餐库存会按下面的子商品扣减。',
    comboSelectChild: '选择子商品',
    comboAddChild: '添加子商品',
    comboEmpty: '该套餐配方还没有子商品',
    comboQuantity: '套餐数量',
    comboAutoBuyPrice: '成本价会根据套餐配方自动计算',
    comboDerivedStock: '库存按子商品计算',
    comboTypeLabel: '商品类型',
    comboTypeNormal: '普通商品',
    comboTypeCombo: '套餐商品',
    comboSelectChildWarning: '请选择套餐子商品。',
    comboQuantityWarning: '子商品数量必须大于 0。',
    comboDuplicateChildWarning: '同一个子商品只能在套餐配方中出现一次。',
    comboChildCannotBeCombo: '子商品不能是另一个套餐商品。',
    comboSelfWarning: '套餐不能包含自己。',
    comboVariantNotSupported: '套餐暂不支持和变体一起使用。请先删除变体再切换为套餐。',
    simpleModeCombWarning: '请在商品列表中完整创建商品',
    comboConvertToNormalBuyPriceWarning: '将套餐改回普通商品时，请重新输入成本价。',
    type: '变体',
    type1: '变化（尺寸、颜色...）',
    typeHint: '变体名称',
    sku: 'SKU代码',
    skuExist: '此 sku 代码已存在。请输入另一个代码！',
    image: '商品照片',
    nameSoShort: '产品名称必须大于 4 个字符',
    nameExist: '产品名称已存在',
    canNotCreateUnitConvertWithType: '无法为具有变体的产品创建转换单位。',
    limitUploadImage: '免费版本仅支持每个产品一张图片。请升级以添加更多照片！',
    limitContentLength: '产品描述必须位于 %s 字符下方！',
    limitImageOffline: '离线版仅支持1张照片！',
    importNewFromExcel: '输入新产品',
    importUpdateFromExcel: '更新现有产品',
    description: '管理和跟踪您的所有货物。'
  },
  category: {
    id: '类别代码',
    prefix: '类别代码前缀',
    title: '产品类别',
    create: '添加类别',
    name: '类别名称',
    choice: '选择类别',
    search: '按代码、类别名称过滤',
    categoryExist: '该类别名称已存在',
    choiceProduct: '选择要添加到目录的商品',
    description: '管理和跟踪您的所有类别',
    tips: '建议',
    tip1: '使用简短、易于理解的类别名称（例如：饮料、快餐...）。',
    tip2: '类别有助于更快地对产品进行分类和搜索。',
    tip3: '您可以在创建后立即将产品分类到此类别中。',
    itemsCountDesc: '此类别中有 %s 产品'
  },
  bestSelling: {
    title: '消费趋势',
    subtitle: '产品30天内畅销'
  },
  importOrder: {
    id: '单码',
    prefix: '输入代码前缀',
    title: '进口订单',
    detail: '进口订单详情',
    create: '添加进口订单',
    edit: '编辑输入表格',
    editProductPrice: '成本价变动',
    editProductPriceWarning: '您想将此商品的成本价更改为 %s 吗？'
  },
  importReturnOrder: {
    id: '单码',
    prefix: '供应商发票代码前缀',
    title: '输入的退货订单',
    detail: '输入的退货订单详细信息',
    create: '添加导入的退货',
    edit: '编辑导入的退货单'
  },
  provider: {
    id: '供应商代码',
    prefix: '供应商前缀',
    title: '供应商',
    create: '添加供应商',
    name: '供应商名称',
    choice: '选择供应商',
    search: '按代码、名称、供应商电话号码过滤',
    categoryExist: '供应商名称已存在',
    order: '命令',
    free: '未确定',
    deleteWarning: '您确定要删除该提供商吗？与该供应商相关的所有订单和收据都将返回“未知”。'
  },
  googleDriver: {
    loginGoogle: '您需要登录您的 Google 帐户才能执行此功能',
    backup: '备份',
    backupToDriver: '备份',
    backupSuccess: '备份成功',
    backupError: '备份失败',
    emptyBackup: '未找到备份',
    loadingBackupFile: '加载备份数据',
    backingUp: '正在备份',
    restore: '恢复',
    restoreFromDriver: '恢复',
    restoreSuccess: '恢复数据成功',
    restoring: '恢复数据',
    resetData: '重新初始化数据',
    resetDataDetail: '从头开始重新创建数据',
    resetDataConfirm: '您确定要擦除当前数据吗？',
    backupErrorCaseInvalidToken: '无法备份数据，因为您的 Google 帐户已过期。请登录并重试！',
    confirmReplaceOlderTitle: '确认覆盖',
    confirmReplaceOlderDetail: '我们在 Google Driver 上找到了更新版本的数据。您确定要备份当前数据吗？',
    restoreChoose: '选择您要恢复的数据',
    backupRename: '编辑名称以便于记住',
    backupAt: '备份于'
  },
  staffUpgrade: {
    upgradeForStaff: '您正在扩展一名员工。如果您之前已付款且尚未更新。请选择付款恢复。',
    staff1m: '又延长1个月',
    staff6m: '再延长6个月',
    staff1y: '再延长1年'
  },
  proVersion: {
    pro: '高级零售套餐（VIP）',
    proDetail: '高级套餐是使用应用程序全部功能的套餐（不包括员工帐户和分支机构分机）。请点击“比较免费 - 高级”了解更多详情。',
    staffAcc: '员工账户个人套餐',
    staffAccDetail: '适用于想要使用员工帐户的商业商店的软件包。第一个员工帐户第一个月免费。一个员工帐户可以在无限的设备上登录。',
    warehouseExt: '扩大分店零售套餐',
    warehouseExtDetail: '分行扩展配套适用于第二家分行及以上。第二个分支将免费使用一个月。',
    linked: '链接',
    paymentRecoveryHint: '请选择您的付款方式以恢复此帐户！',
    name: '高级版',
    detail: '购买应用程序的高级版本后发生的变化',
    removeAds: '购买高级版',
    removeAdsDetail: '您只需支付一次，下次自动恢复',
    paymentRecovery: '付款恢复',
    paymentRecoveryDetail: '恢复您升级到高级版本的付款',
    purchaseFailed: '付款失败。请再试一次。',
    purchaseSuccess: '付款成功，谢谢！',
    recoveryPaymentSuccess: '付款恢复成功！',
    recoveryPaymentUnsuccess: '付款恢复失败。请再试一次！',
    recoveryIfNeed: '如果您之前已付款，请选择恢复您的付款。',
    cancelIfNeed: '取消自动续订。请前往%s进行操作',
    cancelSubsiOS: `Hủy gia hạn tự động trên iphone bạn thực hiện bước như sau ạ.
    - Mở ứng dụng Cài đặt trên iPhone.
    - Chạm vào tên bạn.
    - Chạm vào Đăng ký.
    - iPhone hiển thị tùy chọn menu Đăng ký trong phần Cài đặt.
    - Chạm vào đăng ký mà bạn muốn quản lý
    - Chạm vào Hủy đăng ký `,
    cancelSubsAndroid: `Huỷ gói trên điện thoại android bạn làm các bước sau
    - Vào Ứng dụng CH Play  trên điện thoại Android> Sau đó nhấn vào biểu tượng Tên tài khoản Google
    - Chọn Thanh toán và Gói thuê bao
    - Chọn Gói đăng ký
    - Chọn Gói Quý khách muốn Hủy
    - chọn Hủy
    - Chọn Để sau
    - Chọn Lý do Quý khách muốn hủy gói
    - Chọn Hủy gói thuê bao`,
    canSubs: '取消续订',
    expireDate: '到期日',
    expired: '已到期',
    yourPackage: '您使用的是高级版',
    packageFull: '终身无限量套餐',
    trial: '试用7天',
    trialDetail: '使用高级版本 7 天。\n时间到期后，您将返回免费版本',
    package1M: '1个月套餐',
    package3M: '3个月套餐',
    package6M: '6个月套餐',
    package1Y: '1年套餐',
    package5Y: '5年套餐',
    package10Y: '10年套餐',
    package1MDetail: '使用高级版1个月。\n时间到期后，将自动续订',
    package3MDetail: '使用高级版3个月。\n时间到期后，将自动续订',
    package6MDetail: '使用高级版本 6 个月。\n套餐会随时间累积，并且不会自动续订',
    package1YDetail: '使用高级版本 1 年。\n套餐会随时间累积，并且不会自动续订',
    package5YDetail: '使用高级版本 5 年。\n套餐会随时间累积，并且不会自动续订',
    package10YDetail: '使用高级版本 10 年。\n不自动续订',
    packageWarehouse1Y: '仓库扩建1年',
    packageWarehouse1YDetail: '再添加 1 年延期。\n不要自行续订',
    packageStaff1Y: '员工1年',
    packageStaff1YDetail: '将员工帐户使用权续订 1 年。\n请勿自行续订',
    serviceFee: '服务费',
    serviceFeeDetail: '使用高级服务包可以使用应用程序的全部功能。点击详情可查看信息。',
    packageAutoRenew: '套餐自动续订',
    packageNonAutoRenew: '套餐不会自动续订',
    notFoundPurchase: '未找到您的付款',
    purchaseLinkedWithOtherAcc: '此付款已链接到另一个帐户',
    recoverySumary: '如果您已支付成功但尚未激活高级套餐。请选择“恢复付款”',
    recoverySumary1: '如果不成功，请尝试退出应用程序并重新进入。',
    purchaseProcessing: '付款仍在处理中，请稍等。如果支付成功但仍未更新，请点击恢复支付。',
    iapInLoading: '还没准备好。请稍等',
    yourPackageInfo: '你的包裹',
    compare: '免费比较 - 高级版',
    trialConfirm: '您确定要激活 7 天 PREMIUM 试用版吗？当您的套餐过期后，它将返回到免费套餐',
    trialActive: '激活试用',
    trialActiveDetail: '您正在使用免费版本。您想激活高级版 7 天吗？时间到期后，您将返回免费版本！',
    autoRenewWarning: '取消续订套餐',
    autoRenewWarningDetail: '您采用的是每月自动续订计划。请先取消此套餐，然后再购买更高的套餐，以避免每月扣除！'
  },
  upgrade: {
    hasNewVersion: '有新更新',
    changelog: '新版本的变化',
    upgradeNow: '更新',
    later: '之后',
    changeLogs: [
      '修复选择深色主题时文本模糊的错误',
      '修复了部分设备上无法保存导入订单的错误',
      '优化广告以适应浅色和深色界面',
      '新增向开发者发送错误报告文件的功能',
      '并修复其他一些小错误'
    ]
  },
  profile: {
    title: '个人',
    nameShop: '店铺名称',
    email: '电子邮件',
    address: '地址',
    phone: '电话号码',
    numberPhone: '电话号码',
    edit: '编辑',
    save: '节省',
    bank: 'STK',
    billInfo: '店铺信息',
    placholderBillInfo: '此信息将显示在发票上（电话号码、地址、银行...）',
    placholderBank: '输入银行账户',
    placholderName: '输入店铺名称',
    profileDetail: '更新商店标识和联系信息。',
    changeAvatar: '改变你的头像',
    emailVerified: '电子邮件已被验证且无法更改。',
    placholderEmail: '电子邮件无法更改',
    placholderAdress: '输入地址',
    placholderPhone: '输入电话号码',
    avatarEmpty: '请选择一张照片',
    nameEmpty: '店铺名称不能为空',
    emailEmpty: '邮箱不能为空',
    adressEmpty: '地址不能为空',
    phoneEmpty: '电话号码不能为空',
    freeAcc: '免费',
    proAcc: '高级'
  },
  invoice: {
    stt: '不',
    titleImport: '货物进口订单',
    title: '销售订单',
    titleReturn: '退货表格',
    code: '代码：',
    nameClient: '客户',
    order: '商品编码',
    nameProduct: '商品名称',
    number: 'SL',
    totalPrice: '赚钱',
    price: '总金额',
    money: '单价',
    buyer: '购物者',
    salesman: '推销员',
    writeFull: '（签名，写全名）',
    day: '天',
    month: '月',
    year: '年',
    save: '节省',
    unit: '单元',
    thanks: '谢谢你！',
    draft: '临时发票'
  },
  barcode: {
    title: '条码',
    message: '将相机移至集装箱处进行扫描'
  },
  help: {
    removeAds: '我可以删除广告吗？',
    removeAdsDetail: '您可以通过购买高级版本来删除广告。您无需购买软件包即可完全使用该应用程序的大部分功能。',
    adsNotDisable: '我购买了高级版，但仍然出现广告',
    adsNotDisableDetail:
      '- 转到“左上角的菜单图标”->“高级版”-> 选择“恢复付款”。当出现绿色通知时，表示您已成功恢复付款。广告将不再出现。 \n- 如果出现红色消息，则付款恢复未成功。您请再次检查您的付款。或者iTunes Store帐户是否有相同的支付帐户？ \n- 如果您已成功付款但无法激活付款恢复。请通过电子邮件联系开发人员：xgitdev@gmail.com 获取支持',
    recoveryData: '我可以将数据备份或传输到其他设备吗？',
    recoveryDataeDetail:
      '您可以注册一个帐户，然后打开菜单并选择同步当前数据，这样您就不会再丢失数据了。如果您的设备没有任何数据，您可以跳过同步步骤。\n对于其他设备，您只需使用当前帐户登录即可正常使用。',
    recoveryDataAuto: '可以自动备份数据吗？',
    recoveryDataeAutoDetail: '从4.0版本开始。您无需手动备份数据'
  },
  importFromCSV: {
    textHint: '从此处导入 CSV 文件中的文本数据',
    title: '从 csv 文件快速导入',
    choiceFile: '选择文件',
    intro: '请输入以下内容以创建批量订单。您可以在以下位置查看示例和说明：',
    enterText: '输入文字',
    newCustomer: '新客人',
    productInvalid: '无效商品',
    productInvalidMessage: '产品代码无效。请检查以红色突出显示的产品代码',
    check: '查看',
    save: '保存订单',
    emptyDataMessage: '没有找到订单',
    complete: '导入完成',
    gotIt: '我明白',
    here: '这里',
    syntaxIntro1: '您可以在此处查看示例 CSV 文件。',
    syntaxIntro2: '然后您需要以文本形式打开您的 CSV 文件，然后复制 CSV 文件内容并将其粘贴到输入框中的数据输入框中。',
    syntax: '句法',
    examp: '例如',
    syntaxTut: '请根据以下语法格式化数据。订单由换行符分隔。',
    syntaxDetail:
      '电话号码|客户名称|地址、附加费、商品代码|数量|折扣\n电话号码|客户名称|地址、附加费、商品代码|数量|折扣、商品代码|数量|折扣\n电话号码|客户名称|地址、附加费、商品代码|数量|折扣、商品代码|数量|折扣、商品代码商品|数量|折扣、商品代码|数量|折扣',
    syntaxExamp: '0123456789|阮文雅|河内,10,SP1|5|0\n0123456789|阮文雅|河内,10,SP1|5|0,SP2|4|0\n0123456789|阮文雅|Ha诺伊,10,SP1|5|0,SP2|4|0,SP3|4|0'
  },
  bill: {
    name: '账单',
    title: '付款发票',
    product: '排',
    day: '销售日期',
    amount: 'SL',
    money: 'T.Money',
    totalMoney: '总金额',
    thanks: '谢谢你！',
    createBy: '通过应用程序进行专业销售',
    unit: '单元',
    discount2: '折扣 ％',
    discount1: '金钱折扣',
    customImage: '定制照片',
    customText: '风俗',
    moneyText: '金额（字数）'
  },
  printer: {
    connected: '打印机已连接成功！',
    name: '打印机',
    title: '连接打印机',
    find: '正在寻找蓝牙打印机。请稍等！',
    empty: '未找到打印机',
    unknow: '空洞的',
    pressToConnect: '点击以正确连接您的打印机设备',
    notConnect: '请在设置中连接打印机。',
    trial: '还剩 %s 次试验',
    trialExpired: '你已经用尽了所有的考验。请升级到高级版本才能使用此功能',
    printError: '打印机尚未准备好。请再试一次！',
    devicesTested: '开发团队测试的设备：xPrinter 58iiH、GOOJPRT PT-210',
    choice: '选择打印机',
    require: '支持带 USB 连接的热敏票据打印机。电脑必须先安装打印机驱动才可以连接',
    fixOnWindow: '修复Windows下无法连接的错误',
    printerDriverType: '连接的驱动程序类型',
    printerDriverTypeDetail: '选择您计算机上安装的打印机驱动程序的类型。',
    printerDriverTypeList: ['打印机驱动（品牌驱动）', '司机 Zadig（卖家说明）'],
    printerSizeDetail: '选择您的打印纸张尺寸。支持纸张尺寸 A4、A5、80mm、58mm',
    choiceDriverTypeWarning: '请选择安装的驱动程序类型。'
  },
  importFromExcel: {
    textHint: '从此处导入 Excel 文件中的文本数据',
    title: '从 Excel 文件快速导入',
    choiceFile: '选择文件',
    intro: '请输入以下内容以创建批量订单。您可以在以下位置查看示例和说明：',
    introProduct: '请选择excel文件快速导入商品。请不要选择您从产品列表中导出的文件，因为文件格式不一样。您可以在以下位置查看示例和说明：',
    introProduct1: '您应该使用网页版以便于操作。您必须提前输入单位和类别以便系统识别',
    enterText: '输入文字',
    newCustomer: '新客人',
    productInvalid: '无效商品',
    productInvalidMessage: '产品代码无效。请检查以红色突出显示的产品代码',
    check: '查看',
    save: '保存 %s 项',
    emptyDataMessage: '没有找到订单',
    complete: '导入完成',
    gotIt: '我明白',
    here: '这里',
    found: '找到 %s 物品',
    demo: '样本文件',
    syntaxIntro1: '您一次导入的记录应少于 500 条。您可以拆分为多个文件进行导入。商品不能有相同的名称、代码或 SKU 代码。应删除任何不需要更改的列。您可以参考此处的示例文件。',
    syntaxIntro2: '然后您需要以文本方式打开Excel文件，然后复制Excel文件内容并将其粘贴到输入框中的数据输入框中。'
  },
  unit: {
    id: '单位代码',
    title: '计算单位',
    choice: '选择单位',
    create: '创建新单位',
    name: '单位名称',
    search: '按代码、单位名称过滤',
    exist: '单位名称已存在',
    convert: '换算单位',
    addConvert: '添加换算单位',
    editConvert: '编辑换算单位',
    valueConvert: '转换价值',
    invalidValueConvert: '转换单位信息无效。请再次检查！',
    invalidMainUnit: '请在创建转换单位之前选择主要单位！',
    sameMainUnit: '转换单位不能与主单位相同。请选择其他单位！',
    deleteUnitConvert: '删除转换单位',
    deleteUnitConvertWarning: '您确定要删除此转换单位吗？订单中已使用的转换单位无法删除。',
    choiceMainUnitFirstWarning: '创建转换单位之前，请选择产品的计量单位。',
    tips: '建议',
    tip1: '使用标准测量单位（例如：件、包、盒、纸箱...）。',
    tip2: '计量单位有助于更准确地管理库存和销售。',
    tip3: '您可以直接在产品详细信息部分设置单位换算。'
  },
  timeFilter: {
    today: '今天',
    yesterday: '昨天',
    last7Days: '过去 7 天',
    last30Days: '过去 30 天',
    thisMonth: '本月',
    lastMonth: '上个月',
    custom: '定制',
    choiceMonth: '选择月份',
    choiceStartDate: '开始',
    choiceEndDate: '结尾'
  },
  autoRestoreDb: {
    title: '恢复数据',
    message: '我们检测到您帐户数据的新版本。您想与最新数据同步吗？'
  },
  support: {
    title: '直接支持',
    emailSupportDetail: '您想联系我们。请选择以下联系方式之一。',
    emailSupport: '给开发者发邮件',
    zaloSupportDetail: '如果您需要紧急支持，例如应用程序错误，或有关如何使用的问题和解答。请通过 Zalo 选择支持',
    zaloSupport: '通过 zalo 小组提供支持'
  },
  customerDebt: {
    title: '债务总额',
    total: '未偿债务总额',
    customerDebtStatistial: '客户债务',
    beginningBalance: '期初余额',
    beginningDebts: '期初负债',
    closingBalance: '期末余额',
    closingDebts: '期末负债',
    showAll: '显示所有现金流量',
    simple: '缩短版',
    hideProduct: '隐藏商品',
    timeRange: '时间段',
    displayConfig: '显示配置',
    debtCheckWarning: '（请检查并比对以上信息）',
    scanToPay: '扫描支付码',
    scanToPayHint: '使用银行应用程序或电子钱包扫描代码'
  },
  returnOrder: {
    edit: '编辑退货单',
    create: '添加退货订单'
  },
  maintenance: {
    title: '维护',
    message: '我们的服务器正在进行维护，持续约 %s 分钟。请稍后再试！！！',
    timeout: '抱歉，发生错误。请几分钟后重试。如果仍然无效，请联系我们的支持团队！！！',
    messageTimeout: '我们的服务器有点忙！请尝试重新下载！如果仍然无法下载，请休息大约1-5分钟，然后重试！。非常感谢！',
    networkError: '网络错误',
    networkErrorDetail: '互联网连接错误。请再次尝试检查您的WIFI或4G。如果仍然无法下载，请联系我们寻求帮助！非常感谢！'
  },
  financialBook: {
    title: '现金周转',
    receipts: '收据',
    paymentVoucher: '付款单',
    debt: '债务票据',
    createDebt: '创建借项单',
    moneyFromCustomer: '从客户那里收取的钱',
    moneyForProvider: '花在供应商身上的钱',
    moneyForReturn: '退款退款',
    moneyFromReturn: '退款申请收到的退款',
    idAutoGen: '自动优惠券代码',
    cash: '现金',
    bank: '银行',
    totalFund: '普通基金',
    submitter: '创作者',
    typeCharge1: '接收器类型',
    typeCharge2: '属型',
    receipt: '创建收据',
    vouchers: '创建付款凭证',
    fullName: '姓名',
    submitters: '提交者',
    money: '数量',
    textEmptyFinancial: '您还没有任何收据/付款。',
    accountBank: '收款账户',
    nameBank: '银行账户',
    accountNumber: '帐号',
    accountHolder: '账户所有者',
    receiptForOrder: '订单收据',
    paymentForOrder: '订单付款凭证',
    receiptFromCustomer: '客户收据',
    receiptAutoGenFor: '自动为订单创建收据',
    paymentForProvider: '供应商付款凭证',
    paymentForCustomer: '客户付款凭证',
    paymentVoucherAutoGenFor: '订单自动生成付款凭证',
    autoFinancialCanNotEdit: '该票证是自动生成的。请更正相关订单',
    createType: '创造新的',
    deleteType: '删除分类',
    deleteTypeWarning: '您确定要删除 %s 分类吗？',
    exportBill: '发出选票',
    deleteBill: '删除投票',
    deleteBillWarning: '您确定要删除这张票吗？',
    investment: '投入资金',
    investmentDetail: '投入资金是指从首次销售时到期初计算的总余额（收入-支出）。 \n例如：您选择的时间是本月，那么投资资金就是该月第一天或更早的余额。',
    totalRevenue: '总收入',
    totalSpending: '总支出',
    totalBlance: '总余额'
  },
  sortType: {
    newest: '最新的',
    oldest: '最古老的',
    alphabet: '字母'
  },
  guide: {
    revenue: '总收入',
    expenditure: '总开支',
    title: '给初学者的建议',
    expenseReport: '财政金库书',
    product: '首先，添加您提供的商品或服务。',
    customer: '添加新客户是您在以后的交易中创建客户信息和管理债务的基本操作。',
    provider: '您需要创建一个供应商，以便能够管理与供应商相关的所有数据：联系信息、债务、进口历史记录...',
    order: '订单一旦创建就会被记录并交付给客户......',
    category: '目录是您管理产品类别集合的地方。',
    complete: '您已经掌握了基本操作。 aSeler还有更多专为您设计的功能，继续探索！！'
  },
  productHistoryLog: {
    title: '仓库历史',
    sale: '从仓库导出',
    import: '进入仓库',
    update: '检查库存',
    return: '返回仓库',
    delete: '退款取消',
    amount: '交易数量',
    result: '成交后数量',
    importReturn: '退货'
  },
  orderType: {
    sale: '卖',
    return: '退货',
    importReturn: '进口货物退货',
    import: '进口货物',
    receipt: '收据',
    payment: '付款单',
    debt: '债务票据'
  },
  newCodepush: {
    title: '新的补丁版本',
    des: '有一个新的补丁版本发布了。您想立即更新以获得更稳定的使用吗？',
    cancel: '之后',
    ok: '更新'
  },
  printSetting: {
    ...VI.printSetting,
    tearOffset: '切刀至打印头距离(mm)',
    tearOffsetDetail: '该空间将用于释放足够的纸张进行切割而不会丢失打印内容',
    title: '打印机设置',
    type: '打印机类型',
    typeDetail: '如果打印机只能打印发票，请选择 ESC/POS 打印机。既可以打印标签又可以打印发票的打印机应选择ZPL、TSPL。',
    connection: '打印机',
    size: '打印尺寸',
    qrBank: '在发票底部添加自定义照片',
    qrBankDetail: '您可以添加银行二维码、商店徽标，显示在发票底部。',
    asellerLogo: '显示卖家徽标',
    bluetooth: '蓝牙打印机',
    wifi: 'WIFI打印机',
    deviceIp: '打印机IP地址',
    deviceIpEx: '示例：192.168.1.100',
    invalidIP: '请输入有效的IP！',
    canNotConnectIP: '无法连接到此 IP。请检查您打印机的IP！',
    notReady: '打印机尚未准备好。请先进入打印机设置！',
    support: '支持连接WIFI、蓝牙、USB的ESC/POS热敏打印机。\n注意：票据打印功能不支持标签打印机。\n您可以在首页“销售设备”部分查看支持的打印机。',
    orientation: '打印尺寸尺寸',
    potrait: '纵向',
    landscape: '水平的',
    method: '语言支持',
    esc: '电调/POS、电调...',
    escDetail: '专门用于打印发票的打印机',
    tsc: 'ZPL、EPL、TSPL...',
    tscDetail: '打印机可以打印发票、贴纸、条形码...',
    threshold: '文字的粗细',
    thresholdTypeList: ['合身', '黑暗的', '非常大胆'],
    speed: '打印速度',
    speedTypeList: ['自动的', '慢的'],
    spacingBottom: '下面留白'
  },
  homeOfflineWarning: {
    message: '您正在使用离线功能。请切换到在线以使用更多功能。并且没有数据丢失。',
    helpButton: '在线切换说明'
  },
  statStock: {
    typeChoice: '仓库统计如下',
    inventoryCapital: '现有资本'
  },
  customerGroup: {
    title: '客户群体',
    search: '按名称或代码过滤',
    id: '集团代码',
    prefix: '集团代码前缀',
    create: '添加群组',
    choice: '选择宾客群体',
    choiceCustomers: '将客户添加到群组',
    name: '团体名称',
    tablePrice: '价格表',
    priceHint: '当客户属于该组时，价目表将自动应用于销售订单',
    editNotice: '处于编辑模式 - 点击右上角 "保存" 完成',
    removeCustomer: '您确定要从群组中删除该客户吗？'
  },
  settings: {
    title: '环境',
    garena: '常规设置',
    home: '主页设置',
    order: '订单设置',
    product: '商品安装',
    invoice: '发票设置',
    debt: '设置未结余额',
    point: '积分累积设置',
    salesGroup: '销售与发票',
    systemGroup: '系统与界面',
    businessGroup: '客户与业务',
    accountGroup: '账户与安全',
    displayAndTheme: '显示与主题',
    currencyAndTime: '货币与时间',
    security: '安全',
    stockSettings: '库存设置',
    homeWidgets: '主页小部件',
    pointSettings: '积分配置',
    resetPointTitle: '重置设置',
    systemPermissions: '系统权限',
    invoiceSettings: '发票设置',
    debtSettings: '债务设置',
    orderSettings: '订单设置',
    descOrder: '状态、取整、附加费、计时服务',
    descProduct: '库存、成本价、初始库存',
    descInvoice: '发票模板、VietQR、银行账户',
    descPrinter: '纸张尺寸、蓝牙、Wifi、USB打印机',
    descShift: '开班、结班、现金交接',
    descGeneral: '主题、语言、字体大小、货币、PIN码',
    descHome: '显示收入、图表、财务报告',
    descPermission: '相机、照片库、蓝牙、通知',
    descPoint: '会员奖励积分、兑换比率',
    descShop: '分店、员工管理、销售网站',
    descEInvoice: '电子发票配置与开具',
    descPassword: '更新账户密码',
    descDeleteAcc: '永久删除账户与店铺数据',
    shopManager: '店铺管理员',
    staffRole: '员工',
    granted: '已授权',
    grantPermission: '去授权',
    noVietQRConfig: '未配置VietQR银行账户',
    uploadQRImage: '上传二维码图片',
    s2aHkdGroup: 'S2A-HKD 行业群组',
    s2aHkdGroupDetail: '导出S2A-HKD账簿时的默认行业',
    s2aHkdTaxRate: 'S2A-HKD 默认增值税率 (%)',
    s2aHkdTaxRateDetail: '商品/订单无明确VAT时使用',
    s2aHkdTncnRate: 'S2A-HKD 个人所得税率 (%)',
    s2aHkdTncnRateDetail: '导出S2A-HKD时的个人所得税率(%)',
    manualEnterIPDetail: '如果未检测到打印机，请直接输入IP',
    previewPrint: '打印预览'
  },
  customerPoint: {
    pointShort: '观点',
    point: '累积积分',
    description: '管理客户奖励积分',
    history: '累计历史',
    use: '开启积分累积功能',
    mtpRate: '积分转化率',
    mtpRateDetail: '订单值 %s%s = 1 累积积分',
    ptmRate: '货币兑换率',
    ptmRateDetail: '1 分 = %s%s',
    allowPayment: '允许使用积分付款',
    allowForSaleProduct: '购买折扣商品即可赚取积分',
    allowForOrderPayByPoint: '累积支付订单奖励积分',
    change: '更新累积积分',
    invalidPoint: '无效积分',
    invalidNote: '请输入备注',
    usePoint: '使用积分',
    showPointOnInvoice: '在发票上显示积分',
    reset: '删除所有累积积分',
    resetWarning: '您确定要删除客户当前的所有累积积分吗？'
  },
  shift: {
    title: '结束班次',
    end: '结束班次',
    totalOrder: '发票总额',
    totalMoney: '总轮班费',
    paid: '总交接费',
    staff: '职员',
    cash: '现金',
    bank: '转移',
    emptyOrder: '本班次尚未产生订单。',
    shiftOrder: '轮班订单',
    open: '开班',
    closed: '已关闭',
    opening: '已开班',
    openingAmount: '开班金额',
    handoverType: '交接方式',
    openingAmountDetail: '班次开始时可用的现金金额',
    actualHandoverAmount: '实际交接金额',
    differenceAmount: '差额',
    totalExpectedHandoverAmount: '需要交接的总金额',
    orderUnit: '单',
    currencyUnit: '₫',
    endReport: '班次结算报告',
    ended: '已结班',
    shift: '销售班次',
    shiftClosedDesc: '班次已结算并交接',
    actualHandoverDesc: '员工实际交接金额',
    updatingOnClose: '结班时更新',
    matchedDiffDesc: '金额完全相符',
    checkDiffDesc: '需要核对差异原因',
    diffCalculatedOnClose: '交班后计算',
    searchOrdersPlaceholder: '按订单号、客户、电话搜索...',
    handoverTypeDetail: '员工交接班时收取的收款方式',
    requireOpening: '必须开班',
    requireOpeningDetail: '只有在班次开启时才能创建销售订单',
    settings: '班次设置',
    settingsDetail: '配置开班和交接',
    openError: '无法开班',
    expectedHandoverAmount: '应交金额',
    totalMoneyInShift: '轮班总金额',
    needHandover: '需要交接',
    endConfirm: '您确定要结束此班次吗？'
  },
  warehouse: {
    title: '仓库（分公司）',
    renew: '续费仓库',
    choice: '选择仓库',
    intro: '不同的仓库会有不同的库存、销售、财务……指标。进入“库存管理”创建新仓库。',
    stat: '仓库状态',
    createNew: '创建投票',
    create: '创建仓库',
    checkId: '库存代码',
    name: '仓库名称',
    check: '检查库存',
    createCheck: '创建库存表',
    history: '库存历史',
    noHistory: '尚无库存历史记录。请创建新票证',
    noTransferHistory: '还没有转会历史！',
    totalProduct: '总产品',
    tmpCheck: '临时票',
    cancelCheckConfirm: '您确定要取消这张支票吗？',
    cancelTransferConfirm: '您确定要取消此仓库调拨订单吗？',
    default: '主仓库',
    address: '仓库地址',
    manager: '仓库管理（分公司）',
    detail: '仓库信息',
    transfer: '仓库转运',
    transferCard: '仓库调拨详情',
    checkCard: '库存明细',
    exportCheckCard: '库存盘点表',
    exportTransferCard: '仓库调拨单',
    emptyTargetWarehouse: '目标仓库无效。请选择目的地仓库！',
    limit: '注：每个账户免费获得第2个仓库1个月。过期后，您必须续订才能使用。',
    expired: '该仓库已过期。请更新使用！',
    package1Y: '延长1年',
    importFromExcelHint: '从 Excel 文件快速导入产品。',
    importFromExcelEmptyChange: '没有发现任何变化。',
    stopActive: '停用',
    stopActiveWarning: '当仓库停用时，它将从选择列表中隐藏。您确定要停用此存储库吗？',
    emptyTransferHint: '点击“扫码”或“商品”开始调拨',
    emptyCheckHint: '点击“扫码”或“商品”开始盘点',
    noProduct: '未选择商品'
  },
  homeScreen: {
    ...VI.homeScreen,
    support: '需要支持吗？',
    supportDetail: '请选择下面的支持联系表，以便我们为您提供帮助。',
    hotlineSupportDetail: '热线仅支持办公时间，09:00 - 17:00。',
    changelog: '变更日志',
    changelogDetail: '监视更改日志以了解应用程序的更改和最新功能。',
    autoUpdate: '更新补丁',
    autoUpdateDetail: '系统会更新到最新补丁来修复一些小错误，无需到应用商店安装最新版本。',
    autoUpdateNoAvailable: '您使用的是最新版本！',
    autoUpdateFailed: '更新过程中出现错误。请稍后再试！',
    vipExpired: '您的高级套餐已过期。请更新以使用完整功能！',
    timeZoneNew: '更新时区',
    timeZoneConfirm: '您确定要将报告更新到新时区吗？ You can reset it in "General Settings"',
    timeZoneNewDetail: '您的设备正在使用 %s 时区。我们已根据您当前的时区更新了准确的报告。之前发布的报告可能会发生变化。要查看旧报告，请访问“统计（旧）”'
  },
  productSetting: {
    sort: '对列表进行排序',
    sortDetail: '对产品顺序进行排序',
    sortTypes: ['最新的优先', '名字按字母顺序排列', '最老的在前', '到期日']
  },
  intro: {
    shift: '该功能适用​​于服务型企业。员工使用员工应用程序来结束轮班。此处将显示员工轮班结束信息。',
    customerGroup:
      'This feature is to group customer objects.例如，一级代理、二级代理……您可以为每个客户组创建商品价目表。创建订单时，如果客户属于具有价目表的组，则将自动应用该价目表！',
    emptyProduct: '还没有产品。请添加更多商品以继续！',
    draftOrder: '当您想同时创建多个订单时，此功能适用。即使没有网络连接，您也可以创建销售订单。如果您的连接出现问题或服务器正在维护，这非常有用。'
  },
  printBarcode: {
    print: '打印标签',
    list: '标签列表',
    config: '配置标签',
    size: '1枚邮票尺寸（长x宽）（毫米）',
    note: '笔记',
    column: '打印尺寸的列数',
    paddingH: '2 个印章之间的水平距离（毫米）',
    paddingV: '2枚印章之间的垂直距离（毫米）',
    noteDetail: '如果条形码无法扫描或部分丢失。请使用较大的纸张尺寸，或缩短条形码',
    dpi: '打印机的 Dpi',
    multiUpdateQuantity: '更新批次数量',
    invalidQuantity: '数量无效！',
    barcodeWidth: '代码宽度',
    autoPrintWhenInBill: '打印票据时自动打印标签',
    autoPrintWhenInBillDetail: '当激活该功能时。每次单击“打印发票”时，都会自动打印产品的贴纸。',
    printerNotRealdy: '标签打印机尚未准备就绪。请前往设置打印代码进行更新！',
    contentToDisplay: '标签上显示的内容',
    parameters: '参数',
    lengthXWidth: '长 × 宽 (mm)',
    sampleProduct: '样品产品'
  },
  draftOrder: {
    title: '申请草案',
    manager: '管理草稿订单',
    cancel: '取消草稿',
    cancelConfirm: '您确定要取消此草稿申请吗？',
    noConnectionWarning: '您的设备未连接到网络。转到下面的“管理草稿订单”部分，无需互联网连接即可创建草稿订单。',
    emergencyModeWarning: '您处于紧急模式。订单仅临时保存在您的设备上，尚未记录到服务器。',
    exportInvoice: '出口临时合同'
  },
  deleteAcc: {
    title: '删除帐户',
    warning: '您确定要删除该帐户吗？一旦删除，您将无法恢复数据。您需要将确认码发送到您的电子邮件！',
    confirmCode: '验证码',
    confirmCodeShort: '验证码太短'
  },
  debtNotify: {
    name: '追债通知',
    title: '需追讨的债务',
    money: '收取金额：'
  },
  restartApp: {
    title: '重新启动应用程序',
    detail: '您想重新启动应用程序以使更改生效吗？'
  },
  appError: {
    eyebrow: '发生错误',
    title: '应用需要重新启动',
    detail: '发生意外错误。请重新启动应用后继续使用。',
    reload: '重新启动应用'
  },
  shopSetting: {
    link: '网站路径',
    publicSetting: '设立销售网站',
    publicSettingHint: '顾客可以通过商店发送给顾客的链接直接订购。您需要激活PLUS包才能使用此功能。',
    userName: '商店标识符',
    userNameHint: '该名称将出现在发送给客户的链接上。不得包含空格或特殊字符（允许使用连字符和下划线）。',
    staffRefLink: '员工推荐链接',
    staffRefLinkHint: '链接到员工商店。如果客户点击此链接，将为该员工计算订单',
    customerCanRegister: '允许客户注册帐户',
    customerCanRegisterDetail: '客户可以注册自己的帐户。如果启用，产品价格将向所有客户公开显示。',
    retailPurchase: '允许零售客户进行购买',
    retailPurchaseDetail: '客户无需账户即可创建订单',
    theme: '界面',
    themeDetail: '选择向客户显示的网站界面',
    shopName: '店铺名称',
    banner: '商店横幅照片',
    bannerDetail: '商店横幅照片建议尺寸 1024x512px',
    color: '颜色',
    colorDetail: '编辑销售网站界面的颜色',
    colorTextNormal: '小写颜色',
    colorTextActive: '盲文颜色',
    colorBackground: '背景颜色',
    showPricePublic: '显示价格',
    showPricePublicDetail: '向所有访客公开显示价格',
    initWebsite: '创建网站',
    moreSettingOnWeb: '请使用网页版对销售网站进行更全面的配置。',
    productList: '产品列表',
    productListDetail: '设置销售网站上显示的产品列表。默认显示所有产品',
    promotionList: '促销活动清单',
    promotionListDetail: '设置要在销售网站上显示的促销列表。默认不显示',
    domain: '私有域名',
    domainDetail: '为商店配置独立域名',
    domainDetailWidthIP: '为您的商店配置单独的域名。\n请关闭 Cloudflare 并将域 IP 指向 %s',
    requirePlus: '使用此功能前请先激活PLUS套餐！'
  },
  promotion: {
    edit: '编辑促销活动',
    create: '创建促销活动',
    choice: '选择促销',
    title: '晋升',
    manage: '促销管理',
    detail: '促销详情',
    name: '促销名称',
    code: '促销代码',
    type: '促销类型',
    info: '促销信息',
    order: '发票折扣',
    product: '产品折扣',
    orderGift: '发票礼品',
    productGift: '购买即赠送',
    minMoney: '最低金额',
    minQuantity: '最小数量',
    value: '促销价值',
    price: '促销价',
    discountPercent: '减少%',
    time: '促销期',
    choiceGift: '选择礼物',
    gift: '展示',
    originalPrice: '原价',
    delete: '删除促销',
    deleteConfirm: '您确定要删除此促销活动吗？',
    uniqueQuantity: '%s 的最小数量必须不同！'
  },
  invalidField: {
    name: '请输入有效的姓名字段！',
    timeFrom: '请输入有效的开始时间！',
    timeTo: '请输入有效的结束时间！'
  },
  serviceSale: {
    branch: '分支',
    found: '没有找到合适的产品',
    clickDownload: '点击下载',
    use: '使用',
    empty: '仍然空着',
    table: '桌子',
    emptyTable: '还没有正在使用的表',
    createBranchWarning: '您可以在aSeller管理应用程序上添加新的分支机构',
    addProduct: '添加菜品',
    addProduct1: '添加商品',
    scanBarcode: '扫码',
    changeTable: '更改表',
    orderNotCreate: '订单尚未创建或还没有产品',
    changeTableInput: '输入要更改的桌号',
    error: '错误',
    finish: '完成的',
    selected: '已选择',
    choiceProduct: '选择菜品',
    choiceProduct1: '选择项目',
    addNewProduct1: '添加新项目',
    addNewProduct: '添加新的',
    selectTable: '选择 1 个表继续',
    tableManagement: '办公桌管理'
  },
  payment: {
    payment: '支付',
    cash: '现金',
    transfer: '转移',
    totalMoney: '总金额',
    addOrder: '添加到购物车',
    order: '创建应用程序',
    number: '数量',
    total: '全部的',
    part: '部分',
    client: '客户',
    customRetail: '零售客户',
    detailPayment: '付款详情',
    detailClient: '客户详情',
    nameUser: '客户名称',
    newCustomer: '新客户',
    phone: '电话号码',
    email: '电子邮件',
    address: '地址',
    free: '免费',
    note: '笔记',
    updateOrder: '更新订单',
    discount: '折扣',
    surcharge: '额外费用',
    goodsMoney: '支付：',
    totalAmount: '应收账款总额：',
    notePayment: '一经确认，不可更改'
  },
  button: {
    yes: '有',
    no: '不是',
    ok: '好的',
    cancel: '取消',
    save: '节省',
    delete: '擦除',
    edit: '编辑',
    edit2: '重命名',
    login: '登录',
    logout: '登出',
    success: '完全的',
    finish: '完成的',
    confirm: '确认'
  },
  alert: {
    ...VI.alert,
    orderNotCreate: '订单尚未创建或还没有产品',
    enterFullData: '请输入带星号的所有数据',
    error: '错误',
    emptyBranch: '目前还没有分支机构。请联系店主制作',
    messager: '通知',
    openingDay: '当开始日期早于当前日期时，您无法编辑',
    delete: '您确定要删除此编辑吗？',
    emptyInput: '用户名或密码不能为空',
    success: '成功',
    textEmpty: (value) => {
      return `信息 ${value} 不能为空`;
    },
    department: '您还没有选择设施',
    score: '分数不能大于题目数',
    logout: '您确定要退出该应用程序吗？',
    expiredLessThan7Day: '您的帐户已过期。您有 7 天的时间可以续订',
    expiredGreaterThan7Day: '您的帐户已过期。请联系经理延长期限',
    userNameHasSpace: '用户名不能包含空格',
    userNameIsShort: '用户名必须超过5个字符',
    passwordIsShort: '密码必须超过5个字符',
    emailInvalid: '电子邮件无效',
    productCreateOrUpdateFaild: '保存货物尚未成功。请尝试删除该照片或选择另一张照片。如果错误仍然存​​在，请联系支持团队帮助您解决问题！'
  },
  composition: {
    create: '添加成分',
    title: '成分',
    name: '元件名称',
    intro: '成分是产品的一部分。每种产品可能包含许多不同的成分。您可以在编辑或添加产品部分添加成分信息',
    search: '搜索成分'
  },
  bussinessType: {
    title: '业务类型',
    detail: '选择适合您业务的业务类型',
    type_0: '零售',
    type_1: '杂货店、超市',
    type_2: '咖啡、奶茶',
    type_3: '时尚',
    type_4: '化妆品',
    type_5: '妈妈与宝宝',
    type_6: '面包店',
    type_7: '餐厅',
    type_8: '卡拉OK、台球',
    type_9: '药店',
    type_10: '玩具'
  },
  hourlyService: {
    name: '定时器项目名称',
    nameHint: '定时项目的名称将作为项目出现在发票上',
    defaultName: '使用时间',
    title: '按小时计费',
    detail: '按使用服务的小时数收费。 \n仅支持零售和服务接口',
    tablePrice: '每小时价格表',
    errorData: '无效数据。请输入至少 1 项！',
    stopTime: '停止计数',
    stopTimeWarning: '您想停止服务时间来付款吗？'
  },
  extraTopping: {
    errorSeparateProductNonTopping: '没有配料的产品无法分离',
    list: '配料表',
    isTopping: '这是一道额外的菜',
    detail: '附属于其他商品的一类商品（例如奶茶的水牛脚浇头......）。 \n您将无法将此商品直接添加到订单中。\n额外的顶级商品也将无法用于库存跟踪',
    choice: '选择配料',
    name: '额外的配料',
    canNotAddToOrder: '配料不能直接添加到订单中。'
  },
  comboVoucher: {
    voucher: '优惠券代码',
    activeVoucher: '激活优惠券代码',
    activeVoucherDetail: '已有优惠券代码？在这里激活您的代码。',
    emptyKey: '请输入优惠券代码！',
    choiceData: '请在下方选择您要激活的服务，然后点击激活即可完成。',
    invalidKey: '优惠券代码无效！',
    activeVoucherConfirm: '您确定要激活此代码吗？此操作将是不可逆转的。请仔细核对后再点击同意。',
    activeSuccess: '代码激活成功。请重新加载页面才能生效。'
  },
  protection: {
    active: '启用安全性',
    detail: '不使用后自动使用 PIN 码锁定应用程序',
    enterPass: '需要输入密码',
    pin: '代码',
    pinRequire: '密码必须是4位数字',
    wrongPass: '密码错误',
    forgotPin: '忘记密码',
    forgotPinDetail: '重置 PIN。您必须重新输入您的帐户密码。您确定要这样做吗？'
  },
  extraFee: {
    name: '扩展附加费',
    detail: '销售订单延长附加费。该金额将添加到订单中。如果启用，会显示在销售界面',
    table: '扩展附加费表',
    fields: ['姓名', '默认值', '单元', '地位', '行为']
  },
  introData: [
    {
      title: '欢迎来到卖家 POS！',
      detail: '智能销售管理解决方案，帮助您随时随地掌控店铺。'
    },
    {
      title: '轻松管理订单、产品和客户',
      detail: '只需几个步骤即可跟踪收入、支出、债务、进出口仓库并打印发票。'
    },
    {
      title: '您的数据存储在云平台上，轻松跨多个设备同步。',
      detail: '📶 随时访问，更换设备也不用担心丢失数据！'
    },
    {
      title: '销售管理从未如此简单！',
      detail: '使用 aSeller POS 创建商店、添加产品并立即开始销售。'
    }
  ],
  errorSupport: {
    title: '系统遇到错误',
    detail: '系统出现错误。请将本通知发送给卖家团队以获得最快的支持！\n错误代码：%s',
    support: '请求支持'
  },
  otherApps: [
    {
      title: 'a卖家销售人员',
      detail: '此应用程序适用于员工。您可以在“员工列表-添加”部分创建员工账户。'
    },
    {
      title: 'aSeller POS 离线',
      detail: '不需要互联网的免费销售管理应用程序。无需每月支付维护费。设备上存储的数据。无法在多个设备上使用'
    },
    {
      title: 'a卖家 FNB',
      detail: '专门针对餐厅、咖啡馆、奶茶店的管理应用。帮助店主优化时间并节省成本。'
    }
  ],
  appPermission: {
    title: '应用程序权限',
    photo: {
      title: '照片访问',
      detail: '该应用程序需要访问设备上照片的权限，以更新头像、产品、客户......'
    },
    camera: {
      title: '相机访问',
      detail: '该应用程序需要设备上的相机访问权限才能拍摄头像、产品、客户的照片......'
    },
    bluetooth: {
      title: '蓝牙接入',
      detail: '该应用程序需要蓝牙访问才能通过蓝牙连接打印机设备。'
    },
    notification: {
      title: '通知访问',
      detail: '该应用程序需要通知访问权限才能更新有关您使用的服务的最新信息。'
    }
  },
  orderTemplate: {
    title: '发票样本',
    save: '保存模板',
    list: '合同样本',
    saved: '模板保存成功！',
    name: '让人想起的名字',
    nameWarning: '请输入超过 3 个字符的召回名称',
    delete: '样本删除',
    deleteConfirm: '您确定要删除此样品订单吗？',
    hint: '样品订单可帮助您快速创建类似订单。按住可删除花样'
  },
  printSetting2: {
    manualEnterIP: '手动输入IP',
    bill: '收据打印机',
    billDetail: '热敏打印机用于打印销售发票。支持ESC/POS、ESC、ZPL、EPL、TSPL、DPL、CPCL...',
    label: '标签打印机（不干胶）',
    labelDetail: '热敏打印机用于打印产品标签。支持协议 ZPL、EPL、TSPL、DPL、CPCL...',
    scan: '扫',
    rescan: '再次搜索',
    connect: '连接',
    disconnect: '取消连接',
    connected: '已连接',
    scanning: '搜寻中',
    disconnectConfirm: '您确定要取消与该打印机的连接吗？',
    printerNotFound: '未找到其他打印机！',
    sunmiConnectError: '无法连接商米打印机。请再次检查您的设备！',
    usbConnectError: '无法连接到 USB 打印机。请再次检查您的设备！',
    sunmiDevice: '宣美',
    labelPrinter: '标签打印机',
    billPrinter: '票据打印机',
    chooseConnectionAndDevice: '请在下面选择连接类型和设备',
    chooseWifiOrUsbForLabel: '请在下方选择Wifi或USB以连接打印机',
    printProtocol: '打印协议：',
    blankLinesAfterBill: '打印账单后的空白间距',
    threshold: '打印浓度 (Threshold)',
    thresholdDetail: '调整文字的深浅',
    testPrint: '测试打印',
    alignContent: '内容左/右对齐'
  },
  eInvoice: {
    intro: '与电子发票提供商建立连接并配置电子发票开具',
    title: '电子发票',
    setting: '安装电子发票',
    provider: '电子发票供应商',
    addConnect: '添加连接',
    updateConnect: '修复连接',
    reconnect: '重新连接',
    disconnect: '取消连接',
    disconnectWarning: '取消连接后，您将无法创建和访问该提供商的电子发票。您确定要取消与该提供商的连接吗？',
    account: '帐户',
    userName: '电子发票系统登录名',
    password: '密码',
    passwordDetail: '电子发票系统登录密码',
    linkApi: 'API服务器链接',
    confirm: '通过单击保存。您已同意允许 aSeller 销售管理系统帮助我将发票从 aSeller 传输/接收到我选择的电子发票提供商。',
    taxCode: '税码',
    taxCodeDetail: '企业或营业户的税号',
    settingForEInvoice: '设置电子发票开具（Invoice）',
    allowPublish: '允许开具电子发票',
    autoPublish: '自动开具电子发票',
    invoiceType: '发票类型',
    invoiceTypeData: ['增值发票', '收银发票'],
    invoiceTemSeri: '发票模板和符号',
    info: '开具的发票类型',
    export: '开具电子发票',
    infoDefaultHint: '创建订单时开具的默认发票类型',
    deleteInfoConfirm: '您确定要删除此发票模板吗？',
    addInfo: '添加发票类型',
    updateInfo: '编辑发票',
    infoName: '发票名称',
    infoNameIsShort: '发票名称太短',
    templateInvalid: '发票格式和符号无效',
    sellerInfo: '电子发票上的卖家信息',
    sellerInfoIntro: '如果留空，系统将检索 aSeller 上的商店信息',
    sellerName: '卖家名称',
    sellerAddress: '卖家地址',
    sellerEmail: '卖家电子邮件地址',
    sellerPhone: '卖家电话号码',
    sellerBankName: '银行名称',
    sellerBankAccount: '银行账号',
    invalidField: '请输入完整、有效的信息',
    unauthorized: '连接信息无效。请再次检查您的账户和登录密码！',
    active: '启用电子发票开具',
    auto: '自动开具电子发票',
    autoHint: '每次保存销售订单时，系统都会自动将其传输到链接的电子发票提供商的系统。',
    showOnBill: '显示销售发票上的电子发票查找信息',
    activeForOrderNotPay: '激活所有订单的电子发票导出',
    activeForOrderNotPayHint: '停用后，只有已付款的订单才会开具电子发票',
    invoiceNo: '发票号码',
    transactionID: '交易代码',
    codeOfTax: 'CQT代码',
    reservationCode: '查找代码',
    download: '下载文件',
    checkLink: '查找电子邮件地址：',
    create: '开具电子发票',
    createWarning: '您确定要开具该订单电子发票吗？',
    createAllWarning: '您确定要为所选订单的 %s 开具电子发票吗？',
    tryAgain: '补发',
    creating: '开具电子发票',
    createError: '错误释放',
    reconciliation: '检查电子发票',
    createSuccess: '发布成功',
    search: '输入发票号码、CQT 代码、查找代码',
    providerHint: '您需要注册电子发票提供商的服务并获得一个能够开具电子发票的帐户。如果您没有帐户，请联系支持人员以获取有关注册该服务的说明。',
    emptyEInfoWarning: '请先添加发票类型',
    emptyEConnectWarning: '请先添加与供应商的连接',
    notSupportEditWarning: '注意：aSeller 不支持电子发票开具后编辑。要编辑订单，请在电子发票提供商的系统中进行编辑。',
    autoSign: '自动数字签名并发送给税务机关（M-Invoice）',
    autoSignDetail: '自产电费账单将自动进行数字签名并发送给税务机关。如果关闭该功能。商店需要签署发票并发送给税务机关。仅支持 M-Invoice 提供商',
    notSign: '尚未签署',
    manualSign: '签署发票',
    manualSignWarning: '您确定要签署此发票吗？签字后，发票将被发送至税务机关。 aSeller不支持编辑开具的电子发票'
  },
  servicesSetting: {
    slot: '容量',
    prefix: '前缀名称',
    prefixDefault: '桌子',
    prefixEx: '例如：桌子、房间...',
    title: '安装服务接口',
    area: '区域',
    areaName: '地区名称',
    editArea: '编辑区',
    addArea: '添加区域',
    list: '服务清单',
    editName: '编辑服务名称',
    addAreaHint: '销售区域可在设置-店铺设置中添加',
    stopAreaActive: '停用该区域',
    stopAreaActiveWarning: '您确定要停用该区域吗？',
    notFoundArea: '还没有区域。请在您的商店设置中创建一个新区域。'
  },
  billSetting: {
    qrMoney: '二维码金额',
    qrMoneyDetail: '二维码上显示的可选金额。可能是客户所欠的总金额或订单金额',
    qrMoneyType: ['客户债务总额', '订单金额']
  },
  stats: {
    contributionByStaff: '员工贡献',
    summaryByStaff: '员工概览',
    saleByStaff: '员工销售额',
    revenue: '收入',
    overview: '业务成果',
    productReport: '货物报告',
    orderCount: '总订单数',
    cashflow: '现金周转',
    cashflowIn30Days: '最近30天的现金流量',
    cashflowInThisMonth: '本月现金流',
    cashInflow: '现金流入',
    cashOutflow: '现金流出',
    remainingCash: '剩余现金流',
    netCash: '净现金流量',
    return: '返回',
    customerAndSuppliers: '客户与供应商',
    salesChart: '销售图表',
    openBalance: '初始余额',
    openBalanceDetail: '期初余额是指从初始经营时点至期初计算的余额总额（现金流入-现金流出）。 \n例如：您选择的时间是本月，则初始余额为该月第一天以后的余额。',
    orderFee: '订单成本',
    orderFeeChart: '订单成本图',
    orderFeeDetails: '每日费用明细',
    totalVat: '增值税',
    totalSurcharge: '附加费',
    totalSurchargeByCustomer: '客人支付的附加费',
    totalSurchargeByShop: '附加费由商店支付'
  },
  saleCounter: {
    weekChart: '周线图',
    invoice: '账单',
    paymentSuccess: '付款成功！',
    error: '错误',
    selectVariant: '请选择变体'
  },
  screenText: {
    staffLogin: {
      subtitle: '欢迎回来的工作人员！',
      backToOwnerLogin: '返回店主登录'
    },
    activeVoucher: {
      selectStaff: '选择员工',
      selectWarehouse: '选择仓库',
      requireStaff: '请选择一名员工来更新包！',
      requireWarehouse: '请选择扩展存储库来更新包！'
    },
    setting: {
      generalSubtitle: '管理主要语言和货币。',
      currencyDescription: '报告中显示的货币符号。',
      prefixSubtitle: '设置订单和文档的缩写代码。',
      homeSubtitle: '自定义仪表板主页上显示的信息。',
      aboutSubtitle: '有关版本和技术支持的详细信息。',
      aboutAppName: 'a卖家销售管理',
      aboutAppDesc: '为企业提供专业的销售解决方案。'
    },
    shopSetting: {
      noWebsite: '系统尚未为您的商店创建网站。',
      vipExpired: '专业帐户已过期',
      vipDuration: 'VIP+套餐维护期',
      themeSampleTitle: '界面模板',
      themeSample1: '样品1',
      themeSample2: '样品2',
      advancedSubtitle: '管理网站的高级显示功能。'
    },
    eInvoiceSetting: {
      tabConnect: '连接',
      tabSettings: '配置',
      connectTitle: '连接到电子发票',
      settingsTitle: '系统配置',
      settingsSubtitle: '配置自动发票开具和信息显示。'
    },
    invoiceSetting: {
      bankTab: '银行账户',
      invoiceSubtitle: '配置销售发票的显示信息和选项。',
      bankInfoTitle: '银行信息',
      bankInfoSubtitle: '配置二维码和账户信息以接收转账付款。',
      bankQrTitle: '银行二维码',
      noBankQr: '还没有二维码',
      vietQrBankTitle: '越南QR银行账户'
    },
    orderSetting: {
      orderSubtitle: '配置订单处理并显示销售信息。',
      debtSubtitle: '管理客户债务并在发票上记录债务。',
      hourlySubtitle: '设置基于时间的计费服务（例如：台球时间、卡拉 OK...）。',
      extraTitle: '水电费和额外费用',
      extraSubtitle: '设置订单的附加服务和自动附加费。'
    },
    pointSetting: {
      subtitle: '为客户配置积分累积和兑换系统。'
    },
    detail: {
      basicInfo: '基本信息',
      attributesAndManagement: '物业及管理',
      attributesAndTax: '财产和税收',
      groupInfo: '集团信息'
    },
    detailCustomer: {
      changePasswordDetail: '更改客户账户的登录密码',
      passwordMinLength: '密码必须大于4个字符！'
    },
    customer: {
      taxCodeNotFound: '未找到税码信息'
    },
    receipt: {
      reason: '原因',
      treasurer: '财务主管',
      payer: '提交者',
      creator: '投票者',
      signNameHint: '（签名、全名）'
    },
    dashboard: {
      top1BestSeller: '#1 畅销书',
      noData: '还没有数据',
      noDataHint: '您需要添加产品才能显示此统计信息'
    },
    uploader: {
      chooseImageFile: '选择图像文件',
      chooseExcelFile: '选择 Excel 文件'
    }
  },
  shipping: {
    ...VI.shipping,
    createHint: '您可以手动创建运单，或在已配置时调用物流供应商 API。',
    createMode: '创建方式',
    createModeHintManual: '创建内部运单，并允许手动输入运单号。',
    createModeHintProvider: '调用供应商 API 创建运单，并自动接收运单号。',
    providerModeUnavailable: '该供应商尚未完成 API 配置，将使用手动模式。',
    providerCodeAutoGenerated: '运单创建成功后，运单号将由供应商返回。',
    providerCreateFailed: '无法从供应商创建运单，内部运单未保存。',
    irregularTransitionConfirm: '您选择的状态不属于常规处理流程。您确定要更新吗？',
    invalidProviderConfigJson: 'Credentials 或 settings JSON 无效',
    providerSettings: 'Provider Settings',
    providerSettingsJson: 'Provider Settings (JSON)',
    providerConfigGuide: 'Suggested fields by provider',
    providerAccountInfo: 'Provider Account Information',
    providerConfigFromAccount: '这些信息来自 GHN/GHTK 账户或店铺取货仓信息。',
    manualConfigDescription: '当店铺已经有外部运单号并希望手动录入时使用，不需要 Token 或 API 配置。',
    providerSummary: 'Configuration Summary',
    token: 'Token',
    newToken: 'New Token',
    newTokenPlaceholder: '只有在要替换当前 Token 时才输入新 Token',
    tokenConfigured: '已配置',
    tokenNotConfigured: '未配置',
    configured: '已配置',
    environment: 'Environment',
    autoMappedBaseUrl: 'Auto-mapped API URL',
    customBaseUrl: 'Custom baseUrl',
    serviceTypeId: 'Default Service Type',
    paymentTypeId: 'Default Payer',
    shopId: 'Shop ID',
    partnerCode: 'Partner Code',
    pickupWarehouseInfo: 'Pickup Warehouse Information',
    pickupWarehouseHint: '填写用于 GHTK 自动创建运单的仓库/店铺取货信息。',
    pickupName: 'Pickup Warehouse Name',
    pickupPhone: 'Pickup Warehouse Phone',
    pickupAddress: 'Pickup Warehouse Address',
    pickupProvince: 'Pickup Province',
    pickupDistrict: 'Pickup District',
    pickupWard: 'Pickup Ward',
    advancedSettings: 'Advanced',
    advancedSettingsHint: '仅在需要覆盖 baseUrl 或补充 raw JSON 给 dev/support 时使用。',
    credentialsJsonAdvanced: 'Credentials JSON (Advanced)',
    providerSettingsJsonAdvanced: 'Settings JSON (Advanced)',
    requiredFieldMissing: '请先配置 %s 再保存。',
    environmentList: {
      sandbox: 'Sandbox',
      production: 'Production'
    },
    paymentTypeList: {
      shop: 'Shop Pays',
      customer: 'Customer Pays'
    },
    configFieldLabels: {
      token: 'Token',
      environment: 'Environment',
      baseUrl: 'API URL',
      serviceTypeId: 'Default Service Type',
      paymentTypeId: 'Default Payer',
      webhookSecret: 'Webhook Secret',
      shopId: 'Shop ID',
      pickupName: 'Pickup Warehouse Name',
      pickupPhone: 'Pickup Warehouse Phone',
      pickupAddress: 'Pickup Warehouse Address',
      pickupProvince: 'Pickup Province',
      pickupDistrict: 'Pickup District',
      pickupWard: 'Pickup Ward'
    },
    createModeList: {
      manual: '手动创建',
      provider: '通过供应商创建'
    }
  }
};
